import { ITypedBaseResponse } from "@nkr/models/base-response";
import { ICenterByDistance } from "@nkr/models/center-base";
import { AuthActionCreators } from "@nkr/store/authorization";
import { useAppHookContext } from "@nkr/utils/rest-api";
import { useEffect, useState } from "react";

interface IRetVal {
    list: ICenterByDistance[],
    loading: boolean,
    error: string
}

const useCenterByDistanceList = (centerId: number, distance: number): IRetVal => {
    const { dispatch } = useAppHookContext();
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');
    const [list, setList] = useState<ICenterByDistance[]>([]);

    const fetchData = async () => {
        let config = {
            url: `${__API__}/center/by-distance?centerId=${centerId}&distance=${distance}`,
        };

        try {
            const response: ITypedBaseResponse<ICenterByDistance[]> = await dispatch(AuthActionCreators.apiGet(config));

            if (response && response.data.results && response.data.success) {
                setList(response.data.results);
            } else {
                setError('Unable to load data');
                setList([]);
            }
        } catch (err) {
            setList([]);
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        setLoading(true);
        setError('');

        if (centerId > 0) {
            fetchData();
        }
    }, []);

    useEffect(() => {
        setLoading(true);
        setError('');

        if (centerId > 0) {
            fetchData();
        }
    }, [centerId, distance]);

    return { loading, error, list }
}
export default useCenterByDistanceList;